import React from 'react'
import _ from 'underscore'

class Currency extends React.Component {

  render() {
    if (_.isFinite(this.props.value)) {
      if (Intl && Intl.NumberFormat) {
        let locale = 'en-US'

        if (this.props.currency === 'ZAR') {
          locale = 'en-ZA'
        }

        const formatter = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: this.props.currency
        })

        return (
          <span>{formatter.format(this.props.value)}</span>
        )
      }
      else {
        const prefix = this.props.prefix || this.props.currency

        return (
          <span>{prefix} {this.props.value}</span>
        )
      }
    }
    else if (this.props.placeholder) {
      return (
        <span>{this.props.placeholder}</span>
      )
    }
  }
}

export default Currency